import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import EditPayeePage from './EditPayeePage';
import NumberUtils from '../../utils/NumberUtils';
import StepHeader from '../../includes/StepHeader';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';

import UserManagementStore from '../../stores/UserManagementStore';

let isNominatedUser = false;

class ViewPayeePage extends Component {
  constructor(props) {
    super(props);
    // this.delete=this.delete.bind(this);
    this.state = {
      showEditPayee: false,
    };
    this.showEditPayeePage = this.showEditPayeePage.bind(this);
    this.goBack = this.goBack.bind(this);
    this.showViewPayeePage = this.showViewPayeePage.bind(this);
    this.goToMoveMoneyPage = this.goToMoveMoneyPage.bind(this);
    this.deletePayeeButton = this.deletePayeeButton.bind(this);
    this.goToManagePayee = this.goToManagePayee.bind(this);
    this.getSortCodeDisplayNumber = this.getSortCodeDisplayNumber.bind(this);
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    if (this.props.showEditFromPayee) {
      this.setState({ showEditPayee: true });
    }
    isNominatedUser = UserManagementStore.isNominatedUser();
  }

  componentDidMount() {
    if (!this.state.showEditPayee) {
      sayLandingMessage('Manage Your Payees view payee');
    }
  }

  getSortCodeDisplayNumber() {
    let sortcode = _.split(this.props.payeeData.to_account.sort_code, '-');
    sortcode = NumberUtils.formatSortCode(sortcode[0]);
    return sortcode;
  }

  deletePayeeButton() {
    this.props.deleteFromView(this.props.payeeData);
  }

  goBack(e) {
    this.props.goBack();
    if (!_.isEmpty(e)) {
      e.preventDefault();
    }
  }

  goToManagePayee() {
    this.props.goToManagePayee();
  }

  goToMoveMoneyPage() {
    this.props.goToMoveMoneyPage();
  }

  // delete(){
  //     this.setState({showDelete:true});
  // }
  showEditPayeePage() {
    this.setState({ showEditPayee: true });
  }

  showViewPayeePage() {
    window.scroll(0, 0);
    if (this.props.showEditFromPayee) {
      this.props.goBack();
    } else this.setState({ showEditPayee: false });
  }

  render() {
    return (
      <div className="bow ">
        {this.state.showEditPayee ? (
          <EditPayeePage
            payeeData={this.props.payeeData}
            content={this.props.content}
            goToViewPage={this.showViewPayeePage}
            goToMoveMoneyPage={this.goToMoveMoneyPage}
            goToManagePayee={this.goToManagePayee}
            billerEdit={this.props.billerEdit}
            isSMEUser={this.props.isSMEUser}
            session={this.props.session}
            envConfig={this.props.envConfig}
            user={this.props.user}
          />
        ) : (
          <div
            className="container manage-payee"
            id="site-main"
            role="main"
            tabIndex="-1"
          >
            {/* <span id="accessH1ID" ref = "accessH1ID" tabIndex = "0" className="u-visually-hidden off-screen"> You are on Manage Your Payees view payee page</span> */}
            <StepHeader
              showheaderCrumbs="true"
              onClick={this.goBack}
              headerCrumbsMessage={this.props.content.back}
              headerTitle="Manage your payees"
              headerSubtitle="View payee"
            />

            <div className="row">
              <div className="col-xl1-18 col-lg1-18 col-md1-18">
                {/* <h4 className="manage-payee__view-title">View payee</h4>*/}
                <dl className="c-definitions">
                  <dt className="c-definitions__key">Name</dt>
                  <dd
                    className="c-definitions__value"
                    id={this.props.payeeData.id}
                  >
                    {this.props.payeeData.to_account.name}
                  </dd>

                  <dt className="c-definitions__key">Nickname</dt>
                  {this.props.payeeData.hasOwnProperty('display_name') &&
                  this.props.payeeData.display_name !== '' ? (
                    <dd
                      className="c-definitions__value"
                      id={this.props.payeeData.id}
                    >
                      {this.props.payeeData.display_name}
                    </dd>
                  ) : (
                    <dd className="c-definitions__value">-</dd>
                  )}

                  <dt className="c-definitions__key">Sort code</dt>
                  <dd className="c-definitions__value">
                    {this.getSortCodeDisplayNumber()}
                  </dd>

                  <dt className="c-definitions__key">Account number</dt>
                  <dd className="c-definitions__value">
                    {this.props.payeeData.to_account.account_number}
                  </dd>

                  <dt className="c-definitions__key">Reference</dt>
                  <dd className="c-definitions__value">
                    {this.props.payeeData.reference}
                  </dd>
                </dl>
                <div className="manage-payee__options">
                  <button
                    type="button"
                    className="c-btn c-btn--secondary"
                    onClick={this.goBack}
                  >
                    Back
                  </button>
                  {isNominatedUser ? (
                    ''
                  ) : (
                    <span>
                      <button
                        type="button"
                        className="c-btn c-btn--default"
                        onClick={this.showEditPayeePage}
                        id="edit"
                        aria-labelledby={`edit ${this.props.payeeData.id}`}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        className="c-btn c-btn--default"
                        onClick={this.deletePayeeButton}
                        id="delete"
                        aria-haspopup="true"
                        aria-labelledby={`delete ${this.props.payeeData.id}`}
                      >
                        Delete
                      </button>
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

ViewPayeePage.propTypes = {
  content: PropTypes.object,
  showEditFromPayee: PropTypes.bool,
  goBack: PropTypes.func,
  deleteFromView: PropTypes.func,
  payeeData: PropTypes.object,
  goToMoveMoneyPage: PropTypes.func,
  goToManagePayee: PropTypes.func,
  isSMEUser: PropTypes.bool.isRequired,
};
ViewPayeePage.defaultProps = {
  content: {},
  showEditFromPayee: false,
  payeeData: {},
};

export default ViewPayeePage;
